<template>
	<nav
		class="flex select-none items-center justify-between border-b px-4 pb-[11px] pt-3 transition-all"
		:class="{
			'border-transparent': !border || stickyTop,
			'border-separator-primary': border && !stickyTop,
			'bg-fill-primary': stickyTop
		}"
	>
		<RouterLink to="/undress" custom v-slot="{ navigate }">
			<LogoIcon
				class="h-8 w-8 cursor-pointer text-pink hover:text-pink-light focus:text-pink-dark active:text-pink-dark"
				@click="navigate"
				id="logo-mobile"
			/>
		</RouterLink>
		<LoadingSkeleton
			class="h-10.5 w-16 bg-fill-tertiary dark:bg-fill-primary"
			v-if="user.loading"
		/>
		<div class="flex gap-1.5" v-else>
			<BaseButton
				size="sm"
				color="none"
				@click="open('TopUp')"
				tight
				flat
				v-if="user.current"
			>
				<template #leftIcon>
					<CreditIcon />
				</template>
				{{ user.current.totalCredits }}
				<template #rightIcon>
					<div
						class="m-0.5 flex h-4 w-4 items-center justify-center rounded-full bg-cyan"
					>
						<PlusIcon class="h-5 w-5 flex-shrink-0 text-white" />
					</div>
				</template>
			</BaseButton>
			<BaseButton size="md" color="pink" @click="open('SignIn')" v-else>
				{{ t('TheNavbar.signIn') }}
			</BaseButton>
		</div>
	</nav>
</template>
<script setup lang="ts">
import LogoIcon from '../assets/icons/logo.svg'
import BaseButton from './BaseButton.vue'
import LoadingSkeleton from './LoadingSkeleton.vue'
import CreditIcon from '../assets/icons/credit.svg'
import PlusIcon from '../assets/icons/plus.svg'
import { useModalStore } from '../stores/modal'
import { useUserStore } from '../stores/user'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

const { t } = useI18n()

defineProps<{
	border?: boolean
}>()

const { open } = useModalStore()
const user = useUserStore()

const route = useRoute()

const stickyTop = computed(() => route.meta && route.meta.stickyTop)
</script>
